<template>
  <section class="page-section">
        <div class="form-module">
          <div class="module-body">
            <!-- table -->
            <div class="table-region" style="margin-top: 0" v-loading="tableLoading">
              <el-table size="small" :data="tableData">
                <el-table-column label="子代理类型">
                  <template slot-scope="scope">
                    <p>{{ scope.row.type == 1 ? '公司代理' : '个人代理' }}({{ scope.row.userName }})</p>
                  </template>
                </el-table-column>
                <el-table-column label="销售总金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.saleAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="销售总笔数">
                  <template slot-scope="scope">
                    <p>{{ scope.row.saleNum }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="服务代理等级">
                  <template slot-scope="scope">
                    <p>{{ scope.row.serviceLevel }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="服务订单金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.serviceAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="服务订单笔数">
                  <template slot-scope="scope">
                    <p>{{ scope.row.serviceNum }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="商品代理等级">
                  <template slot-scope="scope">
                    <p>{{ scope.row.productLevel }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="商品订单金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.productAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="商品订单笔数">
                  <template slot-scope="scope">
                    <p>{{ scope.row.productNum }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="table-footer" v-if="page.total > 0">
              <div class="selection-operate"></div>

              <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
                  layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </section>
</template>

<script>
import {
  COMMON,
  distributorChildAgentRank
} from '@/common/api';

export default {
  data() {
    return {
      COMMON,

      id: localStorage.getItem('companyId') && localStorage.getItem('companyId') !== 'null' ? localStorage.getItem('companyId') : null,

      tableData: [],
      tableLoading: false,
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
    }
  },
  methods: {
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      // 子代理排行
      this.getChildAgentRankList()
    },
    /**
     * [getChildAgentRankList description] 子代理排行
     * @return {[type]} [description]
     */
    getChildAgentRankList: function () {
      this.tableLoading = true;

      let params = {
        pageNo: this.page.current,
        pageSize: this.page.size
      }
      if (this.id) {
        params.companyId = this.id
      }

      distributorChildAgentRank(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.data.records || [];
          this.tableLoading = false;
          this.page.total = data.data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    }
  },
  mounted: function () {
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/styles/base/_mixin-font';
@import "../../../common/styles/base/mixin-common";

.table-region {
  margin-bottom: 50px;
}

.statistics {
  margin-top: -10px;
  padding: 10px;
  background: #EFFAFF;
  border-radius: 4px;
  font-size: 0;

  &.default {
    border: 1px solid #D9D9D9;
    background: transparent;
  }

  .item {
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    &+.item {
      margin-left: 80px;
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.item-tab-body {
  margin: 10px 0;
  font-size: $smallFS;

  div {
    position: relative;
    display: inline-block;
    padding: 10px 30px;
    cursor: pointer;

    &.current {
      color: $themeColor;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: $themeColor;
        z-index: 1;
      }
    }
  }
}

.order-list-item {

  &.only-bottom-border {
    border: none;
    border-bottom: 1px solid $separateDefaultColor !important;
  }

  .customTableDropDownListBackgroundColor {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 5px;
    background-color: $customTableDropDownListBackgroundColor;
  }

  .overdue {
    opacity: .5;
    filter: alpha(opacity=50);
  }

  .item-body-body {
    margin: 0 10px;

    &.no-margin {
      margin: 0;
    }

    .item-body-body-header {
      background-color: $colorTitleBg;
    }

    .item-body-body-body {
      padding: 10px 0;
    }
  }
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 27px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 10px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}

.dialog-photo-past {
  position: relative;
  margin: 0 auto;
  padding: 10px 0;

  p {
    margin-bottom: 20px;
    text-align: center;
  }

  .pic-list {
    position: relative;
    margin: 0 auto;
    width: 420px;
    height: 130px;

    .pic-item {
      position: relative;
      width: 110px;
      height: 130px;
      margin: 0 15px;
      background: $colorImgBg;

      img {
        @include position(absolute, 3, 50%, none, none, 50%);
        max-width: 100%;
        max-height: 100%;
        @include translate(-50%, -50%, 0);
      }
    }
  }

  .left-icon,
  .right-icon {
    position: absolute;
    z-index: 5;
    top: 50%;
    margin-top: -20px;
    font-size: 34px;
    color: $swiperArrowColor;
    cursor: pointer;

    &:hover {
      color: $darkButtonBackgroundHoverColor;
    }

    &[disabled="disabled"] {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .left-icon {
    left: 0;
  }

  .right-icon {
    right: 0;
  }
}
</style>
